import {
	Component,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
	WritableSignal,
	signal,
} from '@angular/core';

interface Scope {
	loading: WritableSignal<boolean>;
}

@Component({
	selector: 'ms-content',
	templateUrl: './ms-content.component.html',
	styleUrls: ['./ms-content.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsContentComponent implements OnInit, OnDestroy {
	scope: Scope = {
		loading: signal(true),
	};

	/**
	 * Constructor
	 */
	constructor() {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.scope.loading.set(false);
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
